import { Select } from '@tanium/react-select';

export const TaniumSelect = Select as unknown as React.ComponentType<any>;
